import * as React from "react";
import { Link } from "found";
import { withStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";

const styles = theme => ({
  figure: {
    marginTop: 0,
    marginRight: 0,
    marginLeft: 0
  },

  image: {
    maxHeight: "100%",
    maxWidth: "100%",
    borderWidth: 1,
    borderColor: theme.palette.divider,
    borderStyle: "solid"
  },

  tooltip: {
    backgroundColor: "#ffffff",
    padding: 0
  },

  popper: { opacity: 1 },

  zoomedImage: {
    maxHeight: "100%"
  }
});

const CustomizationAreaArtworkListItem = ({
  classes,
  proof: {
    originalFilename,
    asset: {
      url: { formatted }
    }
  }
}) => (
  <Tooltip
    classes={{
      popper: classes.popper,
      tooltip: classes.tooltip
    }}
    placement="left-start"
    title={
      <img
        className={classes.zoomedImage}
        src={formatted}
        alt={
          originalFilename
            ? `Design proof for ${originalFilename}`
            : "Design proof preview"
        }
      />
    }
  >
    <figure className={classes.figure}>
      <Link to={formatted} target="_blank" rel="noopener">
        <img
          className={classes.image}
          src={formatted}
          alt={
            originalFilename
              ? `Design proof for ${originalFilename}`
              : "Design proof preview"
          }
        />
      </Link>
    </figure>
  </Tooltip>
);

export default withStyles(styles)(CustomizationAreaArtworkListItem);
